import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import * as notify from "shared/notify";
import { isValid } from "components/form-inputs/imageUploader/lib/fileHelper";
import { uploadUnidentifiedImage } from "../lib/imageData";

const BulkUpload = ({ sourcePage, isReadOnly, ...props }) => {
    const fileInput = useRef();
    const [isUploading, setIsUploading] = useState(false);

    const openFilePicker = () => {
        if (isUploading) {
            return;
        }

        fileInput.current.click();
    };

    const onFileChange = async (event) => {
        let files = event.target.files;

        setIsUploading(true);

        const promises = [];
        for (let f = 0; f < files.length; f++) {
            const file = files[f];

            if (isValid(file)) {
                const formData = new FormData();
                formData.append("file", file);

                promises.push(uploadUnidentifiedImage(props.wipKey, sourcePage, formData));
            }
        }

        Promise.all(promises).then((response) => {
            const errors = [];
            var successCount = 0;
            response.forEach((r) => {
                if (r.errors) {
                    r.errors.forEach((e) => {
                        if (e.message) {
                            errors.push(e.message);
                        }
                    });
                } else {
                    successCount = successCount + 1;
                }
            });

            if (errors.length > 0) {
                notify.error(errors.join("<br />"));
            }

            if (successCount > 0) {
                notify.success(`${successCount} uploaded`);
            }

            setIsUploading(false);
            fileInput.current.value = "";

            if (props.refreshData) {
                props.refreshData();
            }
        });
    };

    return (
        <div>
            <div className="hide">
                <input type="file" ref={fileInput} onChange={onFileChange} accept=".jpg,.jpeg,.png" multiple={true}></input>
            </div>
            <button
                className={classnames("button", { "-disabled": isUploading || isReadOnly })}
                onClick={openFilePicker}
                title="Bulk Upload"
                disabled={isReadOnly}
            >
                <FontAwesomeIcon icon={faUpload} />
            </button>
        </div>
    );
};

export default BulkUpload;
